import { DESKTOP_BREAKPOINT, TABLET_BREAKPOINT } from "@/constants/layout";

/** Phone stapelt, ab der Tablet-Containerbreite steht ein Tier in einer Zeile. */
export type BatchAnimalDensity = "phone" | "tablet" | "desktop";

export function batchAnimalDensity(containerWidth: number): BatchAnimalDensity {
  if (containerWidth >= DESKTOP_BREAKPOINT) return "desktop";
  if (containerWidth >= TABLET_BREAKPOINT) return "tablet";
  return "phone";
}

/**
 * Halteband gegen die Klassik-Scrollbar (etwa 15–17 px) und einen Fokusrahmen.
 * theme.space.lg allein (16) liegt unter 17 px: an 768 kippt die Zeile, die
 * Leiste frisst die Breite, der Stapel kommt zurück, die Leiste geht. lg + sm
 * bleibt über diesem Sprung, auch beim Ziehen um 1100–1120 px Fensterbreite.
 */
export function batchRowHoldSlack(space: { lg: number; sm: number }): number {
  return space.lg + space.sm;
}

/**
 * Zeile ab 768 px Container. Eine gemessene 0 bleibt der bisherige Modus,
 * damit das erste Layout vor onLayout den Baum nicht umschaltet.
 * slack hält die Zeile, wenn eine Scrollbar die Breite nur knapp unter 768 zieht.
 */
export function nextBatchAnimalRow(
  containerWidth: number,
  currentlyRow: boolean,
  slack: number,
): boolean {
  if (!(containerWidth > 0)) return currentlyRow;
  if (currentlyRow) return containerWidth + slack >= TABLET_BREAKPOINT;
  return containerWidth >= TABLET_BREAKPOINT;
}

export type BatchTextField = "weight" | "name" | "note";

/** Nächstes Textfeld. „Tier hinzufügen“ ist kein Enter-Ziel. */
export type BatchEnterTarget = "name" | "note" | "next" | "save";

/**
 * Enter im letzten Textfeld eines Tiers springt zum Gewicht des nächsten.
 * Beim letzten Tier bleibt der Fokus auf Speichern, wie bisher.
 * Ein neues Tier entsteht dadurch nicht.
 */
export function batchEnterTarget(
  index: number,
  count: number,
  notesOpen: boolean,
  field: BatchTextField,
): BatchEnterTarget {
  if (field === "weight") return "name";
  if (field === "name" && notesOpen) return "note";
  return index >= count - 1 ? "save" : "next";
}

/** Gesperrtes Gewicht ist kein Enter-Ziel. */
export function batchWeightFocusTarget(weightLocked: boolean): "weight" | "name" {
  return weightLocked ? "name" : "weight";
}
